import styled from 'styled-components'

import { device } from 'utils/style'

export const Column = styled.div<{ width?: string; noMargin?: boolean; alignEnd?: boolean }>`
  @media ${device.laptop} {
    width: 0;
    flex: 1 0 ${({ width }): string => (width ? `calc(${width} - 10px)` : 'auto')};
    max-width: ${({ width }): string => (width ? `calc(${width} - 10px)` : 'none')};
    align-self: ${({ alignEnd }): string => (alignEnd ? 'end' : 'auto')};
  }
`
